import _ from 'lodash';
import { useEffect, useMemo, useRef } from 'react';
function deepEqualArray(arr1, arr2) {
    return _.isEqual(arr1, arr2);
}
// used for search filters
export function useDeepCompareEffect(effect, deps, deepCompareIndices = []) {
    const prevDepsRef = useRef([]);
    const hasChanged = useMemo(() => deps.some((dep, i) => {
        const prevDep = prevDepsRef.current[i];
        if (deepCompareIndices.includes(i)) {
            return !deepEqualArray(dep, prevDep);
        }
        return dep !== prevDep;
    }), [deps, deepCompareIndices]);
    useEffect(() => {
        if (hasChanged) {
            effect();
            prevDepsRef.current = deps;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasChanged, effect]);
}
